module.exports = __webpack_public_path__ + "static/img/loading.cb1fedf0.svg";